<template>
  <div class="BlockLabel">
    <div class="message"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: 'BlockLabel',
  props: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.message {
  text-align: center;
  color: #1e77bc;
}
</style>
